<header class="flex justify-between items-center px-4 md:px-8 h-15 bg-white border-b border-gray-200">
    <div class="flex items-center">
        <img src="images/Logo.svg" alt="Deal Huddle" class="h-7 md:mr-8 cursor-pointer" routerLink="dashboard">
        @for (link of links; let i = $index; track i) {
        <div class="hidden lg:flex items-center gap-1.5 px-4 py-3 h-15 cursor-pointer whitespace-nowrap border-b border-transparent"
            [routerLink]="link.path" routerLinkActive="text-active border-active!">
            <i class="pi" [class]="link.icon"></i>
            {{link.label}}
        </div>
        }
    </div>

    <div class="flex items-center gap-2">
        <p-button label="Submit new deal" icon="pi pi-plus" size="small" styleClass="whitespace-nowrap" (onClick)="submitNewDeal()" />

        <div class="hidden lg:flex items-center cursor-pointer" (click)="userMenu.toggle($event)">
            <p-avatar [label]="initials()" class="mr-1 ml-4" shape="circle" />
            <p class="whitespace-nowrap">{{ currentUser()?.fullName }}</p>
        </div>
        <p-menu #userMenu [model]="userMenuItems" [popup]="true" appendTo="body" />

        <p-button icon="pi pi-bars" [text]="true" severity="secondary" size="large" styleClass="lg:hidden!"
            aria-label="Menu" (onClick)="mobileMenuOpen.set(true)" />
    </div>
</header>

<p-drawer [(visible)]="mobileMenuOpen" position="right" styleClass="!w-80 !max-w-[85vw]">
    <ng-template #header>
        <div class="flex items-center gap-3">
            <p-avatar [label]="initials()" shape="circle" />
            <span class="font-medium">{{ currentUser()?.fullName }}</span>
        </div>
    </ng-template>

    <nav class="flex flex-col">
        @for (link of links; let i = $index; track i) {
        <a class="flex items-center gap-3 px-2 py-3 cursor-pointer text-inherit no-underline"
            [routerLink]="link.path" routerLinkActive="text-active font-medium"
            (click)="mobileMenuOpen.set(false)">
            <i class="pi text-lg" [class]="link.icon"></i>
            {{ link.label }}
        </a>
        }
        <div class="border-t border-gray-200 pt-2">
            <a class="flex items-center gap-3 px-2 py-3 cursor-pointer text-inherit no-underline"
                (click)="logout()">
                <i class="pi pi-sign-out text-lg text-red-500"></i>
                Logout
            </a>
        </div>
    </nav>
</p-drawer>
